module.exports = __webpack_public_path__ + "static/media/opposition-4.2ad0a9b5.png";